import pt_BR from 'datatables.net-plugins/i18n/pt-BR.json'
import es from 'datatables.net-plugins/i18n/es-ES.json'
import { getUserLang } from '@/plugins/lang'

pt_BR.buttons.colvis = 'Exibir Colunas'

let lang = {
    'pt-BR': pt_BR,
    es,
}

lang = lang[getUserLang()] || {}

lang.processing = undefined

lang.searchPlaceholder = lang.search

lang.search = ''

$.extend( $.fn.dataTable.defaults, {
  language: lang,
});
